<template>
    <generic-view
        entity_name="contactTicket"
        title = "Contact Tickets"
        :headers="headers">
    </generic-view>
</template>
<script>
import GenericView from './GenericView'
export default {
    data(){
        return {
            headers:[
                {
                    text: 'Name',
                    value: 'name',
                    type: 'textfield'
                },
                {
                    text: 'Email',
                    value: 'email',
                    type: 'textfield'
                },
                {
                    text: 'Phone',
                    value: 'phone',
                    type: 'textfield'
                },
                {
                    text: 'Message',
                    value: 'message',
                    type: 'textfield'
                },
            ]
        }
    },
    components:{GenericView}
}
</script>